import {actions as A} from '../constants/actions';

export const setUser = user => dispatch => (
  dispatch({
    type: A.SET_USER,
    payload: {user}
  })
);

export const setUserId = userId => dispatch => {
  dispatch({
    type: A.SET_USER_ID,
    payload: {userId}
  })
};

export const setUserTypeId = userTypeID => dispatch => {
  dispatch({
    type: A.SET_USER_TYPE_ID,
    payload: {userTypeID}
  })
};
